import { Skeleton } from "@/components/ui/skeleton";
import { Briefcase, Clock, Zap, Check } from "lucide-react";

const cards = [
  { key: "total",     title: "Total Jobs", field: "totalJobs",     icon: Briefcase, chipBg: "#EDE4F4", chipFg: "#78287C" },
  { key: "pending",   title: "Pending",    field: "pendingJobs",   icon: Clock,     chipBg: "#FEF3C7", chipFg: "#B45309" },
  { key: "active",    title: "Active",     field: "activeJobs",    icon: Zap,       chipBg: "#CCFBF1", chipFg: "#0F766E" },
  { key: "completed", title: "Completed",  field: "completedJobs", icon: Check,     chipBg: "#DCFCE7", chipFg: "#15803D" },
];

const JobsHeader = ({ stats, loading }) => (
  <div className="grid gap-[13px]" style={{ gridTemplateColumns: "repeat(auto-fill,minmax(200px,1fr))" }}>
    {loading
      ? Array.from({ length: 4 }).map((_, i) => <Skeleton key={i} className="h-[88px] rounded-[14px]" />)
      : cards.map((c) => {
          const Icon = c.icon;
          return (
            <div key={c.key} className="sz-card sz-card-hover p-4">
              <div className="flex items-center justify-between">
                <span className="text-xs font-semibold text-[#8A90A2]">{c.title}</span>
                <div className="w-[30px] h-[30px] rounded-[9px] flex items-center justify-center shrink-0" style={{ background: c.chipBg, color: c.chipFg }}>
                  <Icon className="w-4 h-4" />
                </div>
              </div>
              <div className="sz-stat-num mt-2.5 text-[#0C1120]">{(stats[c.field] ?? 0).toLocaleString()}</div>
            </div>
          );
        })}
  </div>
);

export default JobsHeader;
